import React from 'react';
import classNames from 'classnames';
import catHowellAvatar from './cat-howell-avatar.png';
import { SignUpLogo } from '../../../../../dashboard/pages/SignUp/SignUp/SignUpLogo/SignUpLogo';
import css from './AgencyLayout.module.css';
import { G2BadgeTop50, MetaBadge } from '@mm/icons';
import { useResolutionInfo } from '@mm/hooks';
import { MOBILE_THRESHOLD } from '../../../../../editor/constants/screenSize';

type Props = {
  className?: string;
  children?: any;
};

export const AgencyLayout = ({ className, children }: Props) => {
  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_THRESHOLD;
  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.container}>
        <div className={css.section}>
          <div className={css.navbar}>
            <SignUpLogo className={css.logo} color="white" />
            <div className={css.badges}>
              <G2BadgeTop50 />
              <MetaBadge />
            </div>
          </div>

          <div className={css.header}>
            <span className={css.headline}>
              Grow your agency by converting anonymous website traffic into
              sales across your customers
            </span>

            <span className={css.subtitle}>
              Customers.ai for Agencies {''}
              <span className={css.greenHighligted}>lead capture</span> {''}
              and {''}
              <span className={css.greenHighligted}>AI technology</span> {''}
              delivers more leads for clients with less time and resources.
            </span>
          </div>
          {isMobile && children}
          <div className={css.testimonial}>
            <div className={css.avatar}>
              <img src={catHowellAvatar} alt="Cat Howell" />
            </div>
            <div className={css.info}>
              <div className={css.infoHeader}>
                <span className={css.name}>Cat Howell</span>
                <span className={css.position}>
                  Founder & CEO Eight Loop Social
                </span>
              </div>

              <p className={css.quote}>
                “I am super grateful for the Customers.ai team because the lead
                capture and outreach funnels effectively segment and convert
                ideal customers. And you can put it into use across all your ad,
                social and content clients and run with it.”
              </p>
            </div>
          </div>
        </div>

        {!isMobile && children}
      </div>
    </div>
  );
};
